import React, { FC } from 'react'
import { Typography } from '@creditas/typography'
import { useTranslation } from 'react-i18next'

export const NoResultSearch: FC = () => {
  const { t } = useTranslation(['formalization'])
  return (
    <div style={{ width: '100%', marginTop: '100px', textAlign: 'center' }}>
      <Typography variant="h4">{t('not-found-title')}</Typography>
      <Typography variant="textSupport">{t('not-found-subtitle')}</Typography>
    </div>
  )
}
